/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_HighlightInputs */

const en_add_highlight = /** @type {(inputs: Add_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Add Highlight`)
};

const es_add_highlight = /** @type {(inputs: Add_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Añadir aspecto destacado`)
};

const fr_add_highlight = /** @type {(inputs: Add_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Ajouter un point fort`)
};

const de_add_highlight = /** @type {(inputs: Add_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Highlight hinzufügen`)
};

const ja_add_highlight = /** @type {(inputs: Add_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 特徴を追加`)
};

const zh_add_highlight = /** @type {(inputs: Add_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 添加亮点`)
};

const ar_add_highlight = /** @type {(inputs: Add_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ إضافة ميزة`)
};

const id_add_highlight = /** @type {(inputs: Add_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Tambah Sorotan`)
};

const it_add_highlight = /** @type {(inputs: Add_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Aggiungi Punto di Forza`)
};

const ru_add_highlight = /** @type {(inputs: Add_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Добавить особенность`)
};

const pt_add_highlight = /** @type {(inputs: Add_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Adicionar Destaque`)
};

const ko_add_highlight = /** @type {(inputs: Add_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 주요 특징 추가`)
};

/**
* | output |
* | --- |
* | "+ Add Highlight" |
*
* @param {Add_HighlightInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const add_highlight = /** @type {((inputs?: Add_HighlightInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_HighlightInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_add_highlight(inputs)
	if (locale === "es") return es_add_highlight(inputs)
	if (locale === "fr") return fr_add_highlight(inputs)
	if (locale === "de") return de_add_highlight(inputs)
	if (locale === "ja") return ja_add_highlight(inputs)
	if (locale === "zh") return zh_add_highlight(inputs)
	if (locale === "ar") return ar_add_highlight(inputs)
	if (locale === "id") return id_add_highlight(inputs)
	if (locale === "it") return it_add_highlight(inputs)
	if (locale === "ru") return ru_add_highlight(inputs)
	if (locale === "pt") return pt_add_highlight(inputs)
	return ko_add_highlight(inputs)
});